/* istanbul ignore next */
export const showError = (message: $TSFixMe) =>
  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  global.notifier.showError(message);
/* istanbul ignore next */
export const showWarning = (message: $TSFixMe) =>
  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  global.notifier.showWarning(message);
/* istanbul ignore next */
export const showSuccess = (message: $TSFixMe) =>
  // @ts-expect-error TS(7017) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  global.notifier.showSuccess(message);
